import { render } from "./ActiveModelStateChip.vue?vue&type=template&id=a124200c"
import script from "./ActiveModelStateChip.vue?vue&type=script&lang=js"
export * from "./ActiveModelStateChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__